<div style="width: 100%;" class="hidden md:block">
    <style>
        .col-container {
            display: grid;
            grid-template-columns: 34% 33%  33%;
            gap: 0px;
            padding: 0px;
            border: 1px solid #0c2240;
            width: calc(100% - 20px);
            /*margin: 1px 0px;*/
        }

        .col-container.header {
            margin-bottom: 2px;
            background-color: #DBDCDE;
        }

        .col-container div {
            text-align: center;
            font-weight: bold;
        }

        .col-container.header div {
            text-align: center;
            font-weight: bolder;

        }

        .col-container > div {
            height: 100%;
            margin: 0px;
            width: 100%;
            border-radius: 0px;
            padding: 0px;
            padding-top: 9px;
        }

        .col-container > div div {

        }

        .col-container div div svg {
            top: 7px;
            position: relative;
            width: 20px;
            height: 20px;
        }

        .top-radius {
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
        }

        .bottom-radius {
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }

        .col {
            border: 1px solid #0c2240;
            border-right: 1;
            border-left: 0;
            border-bottom: 0;
            min-height: 40px;
            padding: 0px;

        }

        .col.top {
            border-top: 0;
        }

        .col.first {
            border-right: 0;
            padding-top: 0px;
        }

        .col.first div {
            margin: 0px 10px;
            text-align: start;
        }

        .col.first div span {
            margin: 0px 10px;
        }

        .side-tbl {
            width: 20px;
            height: 124px;
            top: 125px;
            position: relative;
            border: 1px solid #5200FF;
            border-radius: 0px 10px 10px 0px;
            background-color: #5200FF;
            color: white;
            text-align: center;
            writing-mode: vertical-rl;
            font-size: 12px;
        }

        .darkborder {
            border-color: #5200FF;
        }
    </style>
    <div style="display: flex;width: 100%;">
        <div class="side-tbl">بسته‌های پراستفاده</div>
        <div style="width: 100%;">
            <div class="col-container header top-radius bottom-radius">
                <div class="col top first">
                    <div>نوع بسته</div>
                </div>
                <div class="col top">
                    <div style="margin-top: -6px;">
                <span>تعداد پرس و جو ماهانه یا تعداد رکورد
                </span>
                        <svg width="24" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM10.1269 6.65484C11.2247 5.83149 12.7158 5.76815 13.8795 6.49544C15.7682 7.67585 15.9824 10.3442 14.3063 11.8108L13 12.9538L13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V12.9538C11 12.377 11.249 11.8284 11.683 11.4486L12.9892 10.3056C13.6559 9.72229 13.5707 8.66095 12.8195 8.19144C12.3642 7.90688 11.7829 7.92661 11.3484 8.23901L10.1485 9.26123C9.72807 9.61938 9.09692 9.5689 8.73877 9.14848C8.38062 8.72807 8.4311 8.09692 8.85152 7.73877L10.0784 6.69361C10.0942 6.68019 10.1103 6.66726 10.1269 6.65484ZM10.5 16.5C10.5 15.9477 10.9477 15.5 11.5 15.5H12.5C13.0523 15.5 13.5 15.9477 13.5 16.5V17.5C13.5 18.0523 13.0523 18.5 12.5 18.5H11.5C10.9477 18.5 10.5 18.0523 10.5 17.5V16.5Z"
                                  fill="#5200FF"/>
                        </svg>
                    </div>
                </div>
                <div class="col top ">
                    <div>هزینه ماهانه</div>
                </div>
            </div>
            <div class="col-container top-radius">
                <div class="col top first ">
                    <div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M3.4479 6.3562L5.56851 13.5776C6.5797 13.1508 7.55002 12.9939 8.48741 13.0354C9.73395 13.0907 10.8541 13.4945 11.8522 13.9563C12.3503 14.1867 12.8351 14.4401 13.2916 14.6786L13.294 14.6798C13.7587 14.9227 14.1932 15.1496 14.6245 15.3488C15.4904 15.7488 16.2524 15.9922 16.9996 15.9922C18.9811 15.9922 20.2681 15.1787 20.8654 14.6887L18.6863 7.43021C18.6861 7.42928 18.6869 7.43078 18.6864 7.43018C18.6846 7.42819 18.6755 7.41918 18.6542 7.40928C18.6064 7.3871 18.5332 7.37751 18.4613 7.39766C16.8913 7.83766 15.4506 7.62072 14.139 7.197C13.298 6.92529 12.4241 6.53319 11.6092 6.16754C11.2184 5.99222 10.8412 5.82297 10.4877 5.676C9.32482 5.19256 8.24704 4.86218 7.13438 4.88896C6.05785 4.91487 4.85395 5.27873 3.4479 6.3562ZM6.13693 15.5132C6.97078 15.1229 7.71436 15.0031 8.39882 15.0335C9.27006 15.0721 10.1162 15.3568 11.0124 15.7714C11.4605 15.9788 11.9039 16.2101 12.3678 16.4524L12.386 16.462C12.8367 16.6975 13.3088 16.9442 13.7857 17.1645C14.7492 17.6096 15.8237 17.9922 16.9996 17.9922C19.7141 17.9922 21.4794 16.8052 22.2697 16.1204C22.8721 15.5985 22.9918 14.816 22.8025 14.1856L20.6019 6.85516C20.2309 5.61944 18.9187 5.19242 17.9216 5.47185C16.859 5.76965 15.8427 5.64561 14.7539 5.29385C14.0109 5.05382 13.3211 4.74318 12.5739 4.40672C12.1585 4.21965 11.7253 4.02459 11.2555 3.82924C10.0126 3.31253 8.62244 2.85256 7.08625 2.88954C5.52173 2.9272 3.90547 3.47611 2.19505 4.79667C1.539 5.30319 1.30351 6.15209 1.5236 6.90157L6.04013 22.2818C6.19574 22.8118 6.75146 23.1152 7.28137 22.9596C7.81128 22.804 8.11471 22.2482 7.9591 21.7183L6.13693 15.5132Z"
                                  fill="#091322"/>
                        </svg>
                        <span>بسته شروع</span>
                    </div>
                </div>
                <div class="col top">
                    <div>
                        تا ۵ هزار
                    </div>
                </div>
                <div class="col top ">
                    <div>
                        رایگان
                    </div>
                </div>

                <div class="col first">
                    <div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M8.65685 4C7.8612 4 7.09814 4.31607 6.53554 4.87868L4.87868 6.53553C4.31607 7.09814 4 7.86121 4 8.65685V15.3431C4 16.1388 4.31607 16.9019 4.87868 17.4645L6.53553 19.1213C7.09814 19.6839 7.86121 20 8.65685 20H11C11 19.4477 11.4477 19 12 19C12.5523 19 13 19.4477 13 20H15.3431C16.1388 20 16.9019 19.6839 17.4645 19.1213L19.1213 17.4645C19.6839 16.9019 20 16.1388 20 15.3431V8.65685C20 7.8612 19.6839 7.09814 19.1213 6.53554L17.4645 4.87868C16.9019 4.31607 16.1388 4 15.3431 4H13C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4H8.65685ZM12 2H8.65685C7.33077 2 6.059 2.52678 5.12132 3.46446L3.46447 5.12132C2.52678 6.059 2 7.33077 2 8.65685V15.3431C2 16.6692 2.52678 17.941 3.46446 18.8787L5.12132 20.5355C6.059 21.4732 7.33077 22 8.65685 22H12H15.3431C16.6692 22 17.941 21.4732 18.8787 20.5355L20.5355 18.8787C21.4732 17.941 22 16.6692 22 15.3431V8.65685C22 7.33077 21.4732 6.059 20.5355 5.12132L18.8787 3.46447C17.941 2.52678 16.6692 2 15.3431 2H12ZM17.2071 6.79289C17.5385 7.12431 17.5953 7.64145 17.3437 8.03688L13.963 13.3494C13.8058 13.5964 13.5964 13.8058 13.3494 13.963L8.03688 17.3437C7.64145 17.5953 7.12431 17.5385 6.79289 17.2071C6.46147 16.8757 6.40471 16.3585 6.65634 15.9631L10.037 10.6506C10.1942 10.4036 10.4036 10.1942 10.6506 10.037L15.9631 6.65634C16.3585 6.40471 16.8757 6.46147 17.2071 6.79289ZM13.2404 10.7596L11.7244 11.7244L10.7596 13.2404L12.2756 12.2756L13.2404 10.7596Z"
                                  fill="#091322"/>
                        </svg>
                        <span>بسته پایه</span>
                    </div>
                </div>
                <div class="col">
                    <div>
                        تا ۱۰۰ هزار
                    </div>
                </div>
                <div class="col">
                    <div>
                        هزینه ثابت ۲,۵۰۰,۰۰۰ تومان
                    </div>
                </div>
            </div>
            <div class=" col-container darkborder">
                <div class="col top first" style="grid-row-start: 1;grid-row-end:4">
                    <div style="margin-top: 30px;">
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M9.79284 0.292893C9.98038 0.105357 10.2347 0 10.4999 0H17.9999C18.4044 0 18.769 0.243642 18.9238 0.617317C19.0786 0.990991 18.9931 1.42111 18.7071 1.70711L14.4142 6L16.5857 6C18.3675 6 19.2599 8.15428 17.9999 9.41421L8.70707 18.7071C8.42107 18.9931 7.99095 19.0787 7.61728 18.9239C7.2436 18.7691 6.99996 18.4045 6.99996 18L6.99996 12H2.91416C1.13235 12 0.240026 9.84571 1.49995 8.58578L2.91416 10H7.99996C8.26518 10 8.51953 10.1054 8.70707 10.2929C8.8946 10.4804 8.99996 10.7348 8.99996 11L8.99996 15.5858L16.5857 8L11.9999 8C11.5955 8 11.2308 7.75636 11.0761 7.38268C10.9213 7.00901 11.0068 6.57889 11.2928 6.29289L15.5857 2H10.9142L2.91417 10L1.49995 8.58578L9.79284 0.292893Z"
                                  fill="#5200FF"/>
                        </svg>
                        <span>بسته رشد</span>
                    </div>
                </div>
                <div class="col top">
                    <div>
                        از ۱۰۰ هزار تا ۱ میلیون
                    </div>
                </div>
                <div class="col top">
                    <div>
                        ۵,۰۰۰ تومان به ازای هر کوئری
                    </div>
                </div>

                <div class="col">
                    <div>
                        از ۱ میلیون تا ۱۰ میلیون
                    </div>
                </div>
                <div class="col">
                    <div>
                        ۱۰,۰۰۰ تومان به ازای هر کوئری
                    </div>
                </div>

                <div class="col">
                    <div>
                        از ۱۰ میلیون تا ۱۰۰ میلیون
                    </div>
                </div>
                <div class="col">
                    <div>
                        ۳۰,۰۰۰ تومان به ازای هر کوئری
                    </div>
                </div>
            </div>
            <div class="col-container bottom-radius">
                <div class="col top first">
                    <div>
                        <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M8.97763 2.53771e-05H6.11814C5.07636 2.53771e-05 4.10916 0.540491 3.56316 1.42773L0.552574 6.31994C0.076724 7.0932 0.181449 8.08997 0.807615 8.74745L10.2764 18.6897C10.4652 18.8879 10.7269 19 11.0005 19C11.2742 19 11.5359 18.8879 11.7247 18.6897L21.1935 8.74745C21.8196 8.08997 21.9244 7.0932 21.4485 6.31994L18.4379 1.42773C17.8919 0.540491 16.9247 2.53771e-05 15.883 2.53771e-05H13.0235C13.0081 -0.000333085 12.9927 -0.000334873 12.9772 2.53771e-05H9.02389C9.00844 -0.000334873 8.99301 -0.000333085 8.97763 2.53771e-05ZM12.3137 2.00003H9.68735L7.95658 6.50001L14.0445 6.5L12.3137 2.00003ZM14.4566 2.00003L16.1873 6.5L19.0005 6.49999C19.0784 6.49999 19.1541 6.50888 19.2268 6.52569L16.7346 2.47593C16.5526 2.18018 16.2302 2.00003 15.883 2.00003H14.4566ZM18.6672 8.5L16.16 8.5L14.1085 13.2866L18.6672 8.5ZM11.0005 15.4614L13.984 8.5L8.01708 8.50001L11.0005 15.4614ZM5.81375 6.50002L7.54452 2.00003H6.11814C5.77088 2.00003 5.44848 2.18018 5.26648 2.47593L2.79011 6.50002L5.81375 6.50002ZM3.33388 8.50002L5.84115 8.50002L7.89256 13.2866L3.33388 8.50002Z"
                                  fill="#091322"/>
                        </svg>

                        <span>
                        بسته اختصاصی
                    </span>
                    </div>
                </div>
                <div class="col top">
                    <div>
                        از ۱۰۰ میلیون به بالا
                    </div>
                </div>
                <div class="col top">
                    <div>
                        <a href="#">
                            <button class="button" style=" margin: 0;margin-top: -5px;margin-bottom: 5px;">
                                <span>تماس با واحد فروش</span>
                                <i class="pi pi-angle-left"></i>
                            </button>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<!--................responsive.................-->
<div class="block md:hidden" style="width: 100%">
    <style>
        .plan-div {
            width: calc(100% - 42px);
            border: 2px solid #ededed;
            border-radius: 10px;
            margin: 10px 20px;
            padding: 10px;
        }

        .plan-div div {
            padding: 5px;
        }

        .plan-div svg {
            top: 7px;
            position: relative;
            width: 20px;
            height: 20px;
        }
    </style>
    <div class="plan-div">
        <div style="font-weight: 800; font-size: 18px;padding:0px 10px">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.4479 6.3562L5.56851 13.5776C6.5797 13.1508 7.55002 12.9939 8.48741 13.0354C9.73395 13.0907 10.8541 13.4945 11.8522 13.9563C12.3503 14.1867 12.8351 14.4401 13.2916 14.6786L13.294 14.6798C13.7587 14.9227 14.1932 15.1496 14.6245 15.3488C15.4904 15.7488 16.2524 15.9922 16.9996 15.9922C18.9811 15.9922 20.2681 15.1787 20.8654 14.6887L18.6863 7.43021C18.6861 7.42928 18.6869 7.43078 18.6864 7.43018C18.6846 7.42819 18.6755 7.41918 18.6542 7.40928C18.6064 7.3871 18.5332 7.37751 18.4613 7.39766C16.8913 7.83766 15.4506 7.62072 14.139 7.197C13.298 6.92529 12.4241 6.53319 11.6092 6.16754C11.2184 5.99222 10.8412 5.82297 10.4877 5.676C9.32482 5.19256 8.24704 4.86218 7.13438 4.88896C6.05785 4.91487 4.85395 5.27873 3.4479 6.3562ZM6.13693 15.5132C6.97078 15.1229 7.71436 15.0031 8.39882 15.0335C9.27006 15.0721 10.1162 15.3568 11.0124 15.7714C11.4605 15.9788 11.9039 16.2101 12.3678 16.4524L12.386 16.462C12.8367 16.6975 13.3088 16.9442 13.7857 17.1645C14.7492 17.6096 15.8237 17.9922 16.9996 17.9922C19.7141 17.9922 21.4794 16.8052 22.2697 16.1204C22.8721 15.5985 22.9918 14.816 22.8025 14.1856L20.6019 6.85516C20.2309 5.61944 18.9187 5.19242 17.9216 5.47185C16.859 5.76965 15.8427 5.64561 14.7539 5.29385C14.0109 5.05382 13.3211 4.74318 12.5739 4.40672C12.1585 4.21965 11.7253 4.02459 11.2555 3.82924C10.0126 3.31253 8.62244 2.85256 7.08625 2.88954C5.52173 2.9272 3.90547 3.47611 2.19505 4.79667C1.539 5.30319 1.30351 6.15209 1.5236 6.90157L6.04013 22.2818C6.19574 22.8118 6.75146 23.1152 7.28137 22.9596C7.81128 22.804 8.11471 22.2482 7.9591 21.7183L6.13693 15.5132Z"
                      fill="#091322"/>
            </svg>
            <span style="margin:0px  10px">بسته شروع</span>
        </div>
        <div style="display: flex">
            <div style="width: 250px;font-weight: 600;color: #80858d;">تعداد پرس و جو ماهانه یا تعداد رکورد</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                تا ۵ هزار
            </div>
        </div>
        <div style="display: flex; border-top: 1px solid #dedede">
            <div style="width: 250px;font-weight: 600;color: #80858d;">هزینه ماهانه</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                رایگان
            </div>
        </div>
    </div>
    <div class="plan-div">
        <div style="font-weight: 800; font-size: 18px;padding:0px 10px">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.65685 4C7.8612 4 7.09814 4.31607 6.53554 4.87868L4.87868 6.53553C4.31607 7.09814 4 7.86121 4 8.65685V15.3431C4 16.1388 4.31607 16.9019 4.87868 17.4645L6.53553 19.1213C7.09814 19.6839 7.86121 20 8.65685 20H11C11 19.4477 11.4477 19 12 19C12.5523 19 13 19.4477 13 20H15.3431C16.1388 20 16.9019 19.6839 17.4645 19.1213L19.1213 17.4645C19.6839 16.9019 20 16.1388 20 15.3431V8.65685C20 7.8612 19.6839 7.09814 19.1213 6.53554L17.4645 4.87868C16.9019 4.31607 16.1388 4 15.3431 4H13C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4H8.65685ZM12 2H8.65685C7.33077 2 6.059 2.52678 5.12132 3.46446L3.46447 5.12132C2.52678 6.059 2 7.33077 2 8.65685V15.3431C2 16.6692 2.52678 17.941 3.46446 18.8787L5.12132 20.5355C6.059 21.4732 7.33077 22 8.65685 22H12H15.3431C16.6692 22 17.941 21.4732 18.8787 20.5355L20.5355 18.8787C21.4732 17.941 22 16.6692 22 15.3431V8.65685C22 7.33077 21.4732 6.059 20.5355 5.12132L18.8787 3.46447C17.941 2.52678 16.6692 2 15.3431 2H12ZM17.2071 6.79289C17.5385 7.12431 17.5953 7.64145 17.3437 8.03688L13.963 13.3494C13.8058 13.5964 13.5964 13.8058 13.3494 13.963L8.03688 17.3437C7.64145 17.5953 7.12431 17.5385 6.79289 17.2071C6.46147 16.8757 6.40471 16.3585 6.65634 15.9631L10.037 10.6506C10.1942 10.4036 10.4036 10.1942 10.6506 10.037L15.9631 6.65634C16.3585 6.40471 16.8757 6.46147 17.2071 6.79289ZM13.2404 10.7596L11.7244 11.7244L10.7596 13.2404L12.2756 12.2756L13.2404 10.7596Z"
                      fill="#091322"/>
            </svg>
            <span style="margin:0px  10px">بسته پایه</span>
        </div>
        <div style="display: flex">
            <div style="width: 250px;font-weight: 600;color: #80858d;">تعداد پرس و جو ماهانه یا تعداد رکورد</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                تا ۱۰۰ هزار
            </div>
        </div>
        <div style="display: flex; border-top: 1px solid #dedede">
            <div style="width: 250px;font-weight: 600;color: #80858d;">هزینه ماهانه</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                هزینه ثابت ۲,۵۰۰,۰۰۰ تومان
            </div>
        </div>
    </div>
    <div class="plan-div" style="border-color: #5100fd">
        <div style="background-color: #5100fd;
    color: white;
    width: 105px;
    position: relative;
    float: left;
    margin: -11px 7px 0px -10px;
    border-radius: 8px;
    border-bottom-left-radius: 0;
    border-top-right-radius: 0;">بسته پُر استفاده
        </div>
        <div style="font-weight: 800; font-size: 18px;padding:0px 10px">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M9.79284 0.292893C9.98038 0.105357 10.2347 0 10.4999 0H17.9999C18.4044 0 18.769 0.243642 18.9238 0.617317C19.0786 0.990991 18.9931 1.42111 18.7071 1.70711L14.4142 6L16.5857 6C18.3675 6 19.2599 8.15428 17.9999 9.41421L8.70707 18.7071C8.42107 18.9931 7.99095 19.0787 7.61728 18.9239C7.2436 18.7691 6.99996 18.4045 6.99996 18L6.99996 12H2.91416C1.13235 12 0.240026 9.84571 1.49995 8.58578L2.91416 10H7.99996C8.26518 10 8.51953 10.1054 8.70707 10.2929C8.8946 10.4804 8.99996 10.7348 8.99996 11L8.99996 15.5858L16.5857 8L11.9999 8C11.5955 8 11.2308 7.75636 11.0761 7.38268C10.9213 7.00901 11.0068 6.57889 11.2928 6.29289L15.5857 2H10.9142L2.91417 10L1.49995 8.58578L9.79284 0.292893Z"
                      fill="#5200FF"/>
            </svg>
            <span style="margin:0px  10px;color: #5100fd">بسته رشد</span>
        </div>
        <div style="display: flex">
            <div style="width: 250px;font-weight: 600;color: #80858d;">تعداد پرس و جو ماهانه یا تعداد رکورد</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                از ۱۰۰ هزار تا ۱ میلیون
            </div>
        </div>
        <div style="display: flex; border-top: 1px solid #dedede">
            <div style="width: 250px;font-weight: 600;color: #80858d;">هزینه ماهانه</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                ۵,۰۰۰ تومان به ازای هر کوئری
            </div>
        </div>
        <div style="border: 1px solid #5200FF;padding: 0px;margin: 0px;width: calc(100% + 22px);margin-right: -11px;"></div>
        <div style="display: flex">
            <div style="width: 250px;font-weight: 600;color: #80858d;">تعداد پرس و جو ماهانه یا تعداد رکورد</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                از ۱ میلیون تا ۱۰ میلیون
            </div>
        </div>
        <div style="display: flex; border-top: 1px solid #dedede">
            <div style="width: 250px;font-weight: 600;color: #80858d;">هزینه ماهانه</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                ۱۰,۰۰۰ تومان به ازای هر کوئری
            </div>
        </div>
        <div style="border: 1px solid #5200FF;padding: 0px;margin: 0px;width: calc(100% + 22px);margin-right: -11px;"></div>
        <div style="display: flex">
            <div style="width: 250px;font-weight: 600;color: #80858d;">تعداد پرس و جو ماهانه یا تعداد رکورد</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                از ۱۰ میلیون تا ۱۰۰ میلیون
            </div>
        </div>
        <div style="display: flex; border-top: 1px solid #dedede">
            <div style="width: 250px;font-weight: 600;color: #80858d;">هزینه ماهانه</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                ۳۰,۰۰۰ تومان به ازای هر کوئری
            </div>
        </div>
    </div>
    <div class="plan-div">
        <div style="font-weight: 800; font-size: 18px;padding:0px 10px">
            <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.97763 2.53771e-05H6.11814C5.07636 2.53771e-05 4.10916 0.540491 3.56316 1.42773L0.552574 6.31994C0.076724 7.0932 0.181449 8.08997 0.807615 8.74745L10.2764 18.6897C10.4652 18.8879 10.7269 19 11.0005 19C11.2742 19 11.5359 18.8879 11.7247 18.6897L21.1935 8.74745C21.8196 8.08997 21.9244 7.0932 21.4485 6.31994L18.4379 1.42773C17.8919 0.540491 16.9247 2.53771e-05 15.883 2.53771e-05H13.0235C13.0081 -0.000333085 12.9927 -0.000334873 12.9772 2.53771e-05H9.02389C9.00844 -0.000334873 8.99301 -0.000333085 8.97763 2.53771e-05ZM12.3137 2.00003H9.68735L7.95658 6.50001L14.0445 6.5L12.3137 2.00003ZM14.4566 2.00003L16.1873 6.5L19.0005 6.49999C19.0784 6.49999 19.1541 6.50888 19.2268 6.52569L16.7346 2.47593C16.5526 2.18018 16.2302 2.00003 15.883 2.00003H14.4566ZM18.6672 8.5L16.16 8.5L14.1085 13.2866L18.6672 8.5ZM11.0005 15.4614L13.984 8.5L8.01708 8.50001L11.0005 15.4614ZM5.81375 6.50002L7.54452 2.00003H6.11814C5.77088 2.00003 5.44848 2.18018 5.26648 2.47593L2.79011 6.50002L5.81375 6.50002ZM3.33388 8.50002L5.84115 8.50002L7.89256 13.2866L3.33388 8.50002Z"
                      fill="#091322"/>
            </svg>

            <span style="margin:0px  10px">  بسته اختصاصی</span>
        </div>
        <div style="display: flex">
            <div style="width: 250px;font-weight: 600;color: #80858d;">تعداد پرس و جو ماهانه یا تعداد رکورد</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                از ۱۰۰ میلیون به بالا
            </div>
        </div>
        <div style="display: flex; border-top: 1px solid #dedede">
            <div style="width: 250px;font-weight: 600;color: #80858d;">هزینه ماهانه</div>
            <div style="width: calc(100% - 250px);text-align: end; padding:0px 10px ;font-weight: 700;">
                <a href="#">
                    <button class="button" style=" margin: 0;">
                        <span>تماس با واحد فروش</span>
                        <i class="pi pi-angle-left"></i>
                    </button>
                </a>
            </div>
        </div>
    </div>
</div>